module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('table', {
    staticClass: "chapter-title-corner-decorations",
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "chapter-title-corner-decoration-left-column"
  }, [_c('div', {
    staticClass: "chapter-title-corner-decoration-left-column"
  }, [_c('img', {
    staticClass: "chapter-title-corner-decoration-left",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_corner_decoration_left.png"
    }
  })])]), _c('td', {
    staticClass: "chapter-title-corner-decoration-middle-column"
  }), _c('td', {
    staticClass: "chapter-title-corner-decoration-right-column"
  }, [_c('div', {
    staticClass: "chapter-title-corner-decoration-right-column"
  }, [_c('img', {
    staticClass: "chapter-title-corner-decoration-right",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_corner_decoration_right.png"
    }
  })])])])])]), _c('div', {
    staticClass: "chapter-title"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-above"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-above-inner"
  }, [_c('img', {
    staticClass: "chapter-title-decoration-above",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_above.png"
    }
  })])]), _c('h1', {
    staticClass: "chapter-title"
  }, [_vm._v("Dante Black/Parker James")]), _vm._v(" "), _c('div', {
    staticClass: "chapter-title-decoration-below"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-below-inner"
  }, [_c('img', {
    staticClass: "chapter-title-decoration-below",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_below.png"
    }
  })])])]), _c('p', {
    staticClass: "first-in-chapter",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('span', {
    staticClass: "first-chapter-phrase"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("I")]), _vm._v(" had no qualms taking")]), _vm._v(" out Stanley, the first hit I went after from the Inner Circle. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("While I had done a lot of dirty jobs for all the members of the Inner Circle, Stan was the worst.  He always had someone that he wanted taken out.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Here was the man who had sent me to kick a guy’s head in because the poor guy had infringed on Stan’s territory.  ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Here was the man who had made me kill a fifteen year old kid who had stupidly dared to stand up to Stan when I was just fifteen years old.  The only reason Stan wanted him dead was to prove a point.  His way of telling all the other guys out there not to fuck with him.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Stanley knew I had a mechanical heart.  He knew I was cold.  He knew that I had no empathy for my victims.  He knew that snapping a man’s neck was no different to me than snapping a twig.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("But I also knew that Stanley, like all the five Founders of the Inner Circle, including my own father, had trained his own offspring to become an assassin, just like I had been trained and groomed since childhood. I knew, like I was trained, to avenge the very parent who was a Founder. It was the assurance the Founders had against each other in case they ever went against each other. There will be revenge, and it would be from a very well-trained assassin who took the hit very personally.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("So, I knew, Stanley’s offspring would be going after me soon. What I didn’t know was who the offspring was besides his Code Name. All I knew was that he was given a name that was part of the storybook, The Wizard of Oz, just like I had. My Code Name was Tin Man. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("And he was the Scarecrow. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Now I not only had to carry out my mission to eliminate the rest of the Founders of the Inner Circle, who had killed my father and ordered the death of me, along with my former assignment and target... Summer Jones, the girl who stole my heart; but I had to do it as soon as possible, before I get eliminated by the Scarecrow, and also the other offsprings of the Founders, who by now, were tipped off to what was going on. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I picked up my phone to give Ace, my assistant - a thief and hacker whom I had saved from the cartel, and was now only a handful of people who knew me as being the former Dante Black and now Parker James – a heads up.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Hey, what’s up, Boss?” Ace asked in his casual laid back style.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Now that one of the Founders is dead, the other three would be tipped off and on high alert. They’re going to be sending the rest of the Offsprings at us. Stanley’s own son, The Scarecrow, had already made an appearance, when Stanley’s record company made the announcement that Stanley died in a tragedy, but the company’s helm would go to his son, who will be releasing their newest record named The Scarecrow.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“It doesn’t get clearer than that,” Ace said. “So, what’s the plan?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Come back to the Malibu house,” I said. “Let’s discuss it there. Nothing over the phone now. They may not know it was me, but they will begin tracing any contact Stanley had over the last couple of months.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Gotcha,” Ace said. “I’ll stay off the phone with you on any I.C. or “Inner Circle” stuff.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Good,” I said. “I’ve got a plan, but it requires a lot of stealth, guts, and yeah, nuts. Think you can handle it?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I haven’t back away from anything you’ve gotten me into before, have I?” Ace asked. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“No, good,” I said. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Yeah, after I learned how the I.C. had screwed up my life and my family’s no matter how small our little mom and pop business was, I want to bring them down, too,” Ace said. “Not to mention that they were responsible for the Cartel going after me, too.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Yeah,” I said. “That, too.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“So, yes, I’m in all the way,” Ace said. “By-the-way, any idea who the Scarecrow is? Any of the Offsprings?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Good,” I said. “No, I don’t know the real identity of Scarecrow or the other Offsprings. It was always something that made my dad’s role as the head of the Inner Circle at a disadvantage, just to prove his loyalty to the Inner Circle. My dad allowed my identity as Dante Black, his own son to be revealed to all in the Inner Circle, including their offspring, and to allow them to use me as their assassin, just to prove how good I was. How devoted my dad was to the organization that he gave his son completely over to its cause. Meanwhile, their offsprings were not known to Dad and me. The Inner Circle supposedly had offsprings and had trained them in their own way. Over the years, I’ve heard of some assignments they’ve been sent to do and had accomplished, but I never got cozy with any of them nor did I had the time to. I was busy doing Inner Circle stuff, running my family’s legitimate business, Black Biotech, and going to school. So, to answer your question about who the Offsprings are... I could only guess who, based on a few clues, but no, I didn’t grow up knowing them at all.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Well, then they could be anyone,” Ace said. “Better keep our wits about us.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Exactly,” I said. “See you soon.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "large",
      "page-break-before": "always",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Chapter 1")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-269ca73a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c004.vue
// module id = 69
// module chunks = 0